import { render, staticRenderFns } from "./directdebitrule.vue?vue&type=template&id=0863a202"
import script from "./directdebitrule.vue?vue&type=script&lang=js"
export * from "./directdebitrule.vue?vue&type=script&lang=js"
import style0 from "./directdebitrule.vue?vue&type=style&index=0&id=0863a202&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports